/* assets/in-store-pickup.js
   Works with your snippet JSON structure.
   Uses MANUAL stores injected into each variant as "stores".
   No backend dependency. Updates when variant id input changes.
*/
(function () {
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function getVariantIdFromTheme() {
    // Most themes keep a hidden input name="id" inside the product form
    var el = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return el ? el.value : null;
  }

  function safeJSON(text) {
    try { return JSON.parse(text); } catch (e) { return null; }
  }

  function initOne(root) {
    if (root.__isp_inited) return;
    root.__isp_inited = true;

    var dataEl = qs(root, '.isp__data');
    if (!dataEl) return;

    var data = safeJSON(dataEl.textContent || '');
    if (!data || !data.variants) return;

    var rowBtn = qs(root, '.isp__row');
    var modal = qs(root, '.isp__modal');
    var select = qs(root, '.isp__select');
    var status = qs(root, '.isp__status');
    var address = qs(root, '.isp__address');

    var img = qs(root, '.isp__pimg');
    var ptitle = qs(root, '.isp__ptitle');
    var pprice = qs(root, '.isp__pprice');

    if (!rowBtn || !modal || !select || !status) return;

    function open() {
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('isp-lock');
    }

    function close() {
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('isp-lock');
    }

    qsa(root, '[data-isp-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close();
    });

    rowBtn.addEventListener('click', function () {
      syncFromCurrentVariant();
      open();
    });

    function moneyFallback(v) {
      // Liquid already formatted this as a string like "€12,00"
      return v || '';
    }

    function getVariantObj(variantId) {
      var key = String(variantId || '');
      return (data.variants && data.variants[key]) ? data.variants[key] : null;
    }

    function getStoresForVariant(vObj) {
      // Manual stores are injected as vObj.stores.
      // If you ever move them to top-level data.stores, this still works.
      if (vObj && Array.isArray(vObj.stores) && vObj.stores.length) return vObj.stores;
      if (data && Array.isArray(data.stores) && data.stores.length) return data.stores;
      return [];
    }

    function setProductUI(vObj) {
      if (!img || !ptitle || !pprice) return;

      var productTitle = (data.product && data.product.title) ? data.product.title : '';
      var fallbackImg = (data.product && data.product.image) ? data.product.image : '';

      img.src = vObj.image || fallbackImg || '';
      img.alt = productTitle;
      ptitle.textContent = productTitle;
      pprice.textContent = moneyFallback(vObj.price);
    }

    function fillSelect(stores) {
      while (select.firstChild) select.removeChild(select.firstChild);

      var placeholder = document.createElement('option');
      placeholder.value = '0';
      placeholder.textContent = 'Select store';
      select.appendChild(placeholder);

      if (!stores.length) {
        select.disabled = true;
        return;
      }

      select.disabled = false;

      for (var i = 0; i < stores.length; i++) {
        var o = document.createElement('option');
        o.value = String(i + 1);
        o.textContent = stores[i].name || ('Store ' + (i + 1));
        select.appendChild(o);
      }
    }

    function setStoreUI(store) {
    // address block may not exist in markup OR may be empty in data
    var hasAddressEl = !!address;

    if (!store) {
        status.textContent = '';
        status.className = 'isp__status';
        if (hasAddressEl) address.innerHTML = '';
        return;
    }

    if (store.available) {
        var extra = store.pick_up_time ? (' — ' + store.pick_up_time) : '';
        status.textContent = (root.dataset.availableText || 'Available for pickup') + extra;
        status.className = 'isp__status isp__status--good';
    } else {
        status.textContent = root.dataset.unavailableText || 'Product not available in this store.';
        status.className = 'isp__status isp__status--bad';
    }

    if (hasAddressEl) address.innerHTML = store.address_html || '';
    }

    function setNoStoresUI() {
    status.textContent = root.dataset.onlineOnlyText || 'Only available online';
    status.className = 'isp__status isp__status--bad';
    if (address) address.innerHTML = '';
    }


    function syncFromCurrentVariant() {
      var variantId = getVariantIdFromTheme() || root.getAttribute('data-initial-variant-id');
      var vObj = getVariantObj(variantId);
      if (!vObj) return;

      setProductUI(vObj);

      var stores = getStoresForVariant(vObj);
      fillSelect(stores);

      // reset store view each time variant changes
      select.value = '0';

      if (!stores.length) {
        setNoStoresUI();
      } else {
        // empty until a store is selected
        setStoreUI(null);
      }
    }

    select.addEventListener('change', function () {
      var variantId = getVariantIdFromTheme() || root.getAttribute('data-initial-variant-id');
      var vObj = getVariantObj(variantId);
      if (!vObj) return;

      var stores = getStoresForVariant(vObj);
      var idx = parseInt(select.value, 10) - 1;
      var store = (idx >= 0 && stores[idx]) ? stores[idx] : null;

      setStoreUI(store);
    });

    // Track variant changes (works for most themes that update [name="id"])
    document.addEventListener('change', function (e) {
      if (!e || !e.target) return;
      if (e.target.name === 'id') {
        root.setAttribute('data-initial-variant-id', e.target.value);
        // Keep UI in sync even if modal is closed
        syncFromCurrentVariant();
      }
    });

    // initial
    syncFromCurrentVariant();
  }

  function boot() {
    var blocks = document.querySelectorAll('.isp');
    for (var i = 0; i < blocks.length; i++) initOne(blocks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
